/**
 * input.js
 */

import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';


export default function Input(props) {
  const {
    formContext: formContextProp,
    name,
    type,
    rules,
    defaultValue,
    ...rest
  } = props;
  
  const formContextDefault = useFormContext();
  const formContext = formContextProp || formContextDefault;

  
  return (
    <Controller
      control={formContext.control}
      name={name}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field: { ref, value, onChange, ...inputProps } }) => {
        return (
          <input
            type={type}
            value={value}
            onChange={e => onChange(e.target.value)}
            ref={ref}
            {...rest}
          />
        );
      }}
    />
  );
}